<template>
  <section>
    <v-container>
      <v-layout row wrap>
        <v-flex lg12 sm12 xs12>
          <v-card flat class="biometria-card">
            <v-card-text
              v-if="authLoading"
              class="d-flex justify-center align-center"
              style="min-height: 200px"
            >
              <v-progress-circular indeterminate color="primary" size="40" />
            </v-card-text>

            <v-card-text
              v-else-if="!authReady"
              class="d-flex flex-column justify-center align-center text-center"
              style="min-height: 200px"
            >
              <v-icon color="red" size="48" class="mb-3"> error_outline </v-icon>

              <div class="font-weight-medium mb-2">
                Não foi possível iniciar a validação da biometria
              </div>

              <div class="mb-4">
                O sistema de autenticação da biometria não está respondendo. Por favor tente
                novamente em alguns minutos e caso o problema continue entre em contato com a ARCE.
              </div>
            </v-card-text>

            <!-- BIOMETRIA -->
            <template v-else>
              <v-card-title class="app-card-title d-flex justify-center">
                Validação de Biometria
              </v-card-title>

              <v-card-text>
                <!-- Instruções contextualizadas por tipo de foto -->
                <div class="d-flex justify-center text-center mb-4">
                  <span>Escolha o modo de captura da sua foto:</span>
                </div>

                <!-- Instruções para Selfie -->
                <v-card v-if="mode === 'camera'" class="mb-4" outlined>
                  <v-btn
                    outlined
                    color="primary"
                    class="mr-3 ma-5"
                    :disabled="isLoading || locked"
                    @click="backToStep1"
                  >
                    <v-icon left>arrow_back</v-icon>
                    Voltar
                  </v-btn>
                  <v-card-title class="subtitle-2 font-weight-bold primary--text">
                    <v-icon class="mr-2" color="primary">camera_alt</v-icon>
                    Instruções para Selfie (Tirada pelo celular)
                  </v-card-title>
                  <v-card-text class="py-3">
                    <v-list dense class="py-0">
                      <v-list-item class="px-0">
                        <v-list-item-icon class="mr-3 my-0">
                          <v-icon small color="primary">check_circle</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content class="py-1">
                          <div class="body-2">Fundo branco obrigatório e local bem iluminado</div>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item class="px-0">
                        <v-list-item-icon class="mr-3 my-0">
                          <v-icon small color="primary">check_circle</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content class="py-1">
                          <div class="body-2">
                            Tire uma selfie do peito para cima, rosto centralizado e bem visível,
                            olhando para a câmera (como foto 3x4)
                          </div>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item class="px-0">
                        <v-list-item-icon class="mr-3 my-0">
                          <v-icon small color="primary">check_circle</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content class="py-1">
                          <div class="body-2">
                            Não fazer gestos ou poses, sem acessórios que dificultem a identificação
                          </div>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item class="px-0">
                        <v-list-item-icon class="mr-3 my-0">
                          <v-icon small color="primary">check_circle</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content class="py-1">
                          <div class="body-2">
                            Sem óculos, boné, chapéu ou qualquer acessório que cubra o rosto
                          </div>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-card-text>

                  <div class="d-flex justify-center text-center mb-4">
                    <span
                      >Primeiro faça o teste da biometria, caso seja válida clique no captcha e
                      confirme no botão abaixo.</span
                    >
                  </div>
                </v-card>

                <!-- Instruções para Foto 3x4 -->
                <v-card v-if="mode === 'upload'" class="mb-4" outlined>
                  <v-btn
                    outlined
                    color="primary"
                    class="mr-3 ma-5"
                    :disabled="isLoading || locked"
                    @click="backToStep1"
                  >
                    <v-icon left>arrow_back</v-icon>
                    Voltar
                  </v-btn>
                  <v-card-title class="subtitle-2 font-weight-bold primary--text">
                    <v-icon class="mr-2" color="primary">photo</v-icon>
                    Instruções para Foto 3x4
                  </v-card-title>
                  <v-card-text class="py-3">
                    <v-list dense class="py-0">
                      <v-list-item class="px-0">
                        <v-list-item-icon class="mr-3 my-0">
                          <v-icon small color="primary">check_circle</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content class="py-1">
                          <div class="body-2">
                            A foto deve ser recente (de preferência dos últimos 6 meses)
                          </div>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item class="px-0">
                        <v-list-item-icon class="mr-3 my-0">
                          <v-icon small color="primary">check_circle</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content class="py-1">
                          <div class="body-2">Fundo branco obrigatório em local bem iluminado</div>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item class="px-0">
                        <v-list-item-icon class="mr-3 my-0">
                          <v-icon small color="primary">check_circle</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content class="py-1">
                          <div class="body-2">
                            Rosto centralizado e bem visível, foto nítida, sem sombra ou borrão
                          </div>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item class="px-0">
                        <v-list-item-icon class="mr-3 my-0">
                          <v-icon small color="primary">check_circle</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content class="py-1">
                          <div class="body-2">Sem bordas, manchas ou sujeiras na imagem</div>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item class="px-0">
                        <v-list-item-icon class="mr-3 my-0">
                          <v-icon small color="primary">check_circle</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content class="py-1">
                          <div class="body-2">
                            Sem acessórios que dificultem a identificação (boné, chapéu ou óculos
                            escuros)
                          </div>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-card-text>

                  <div class="d-flex justify-center text-center mb-4">
                    <span
                      >Primeiro faça o teste da biometria, caso seja válida clique no captcha e
                      confirme no botão abaixo.</span
                    >
                  </div>
                </v-card>

                <div v-if="step === 1" class="mt-5">
                  <v-row justify="center">
                    <v-col cols="12" md="6" class="text-center">
                      <v-btn large block color="primary" class="mb-3" @click="chooseMode('upload')">
                        Enviar foto 3x4
                      </v-btn>

                      <v-btn large block color="primary" @click="chooseMode('camera')">
                        Tirar Selfie Agora
                      </v-btn>
                    </v-col>
                  </v-row>
                </div>

                <div v-if="step === 2" class="mt-4">
                  <UploadBiometria
                    :nome="'Foto 3x4 *'"
                    :mode="mode"
                    :isFoto="true"
                    :fileErro="fileTypeError"
                    :fileTypeErro="fileTypeError"
                    :fileName="selectedFileName"
                    :disabled="locked"
                    @file="onFileSelected"
                  />

                  <v-row class="mt-3" justify="center">
                    <v-col cols="12" md="6" sm="12" class="d-flex justify-center align-center">
                      <v-btn
                        color="primary"
                        :loading="isLoading"
                        :disabled="!file || isLoading || locked"
                        @click="onValidateClick"
                      >
                        Testar Biometria
                      </v-btn>

                      <v-icon v-if="validationStatus === 'error'" color="red" class="ml-3" small>
                        error
                      </v-icon>
                    </v-col>
                  </v-row>
                </div>
              </v-card-text>
            </template>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </section>
</template>

<script>
import { mapActions, mapMutations } from 'vuex';
import GlobalStore from '@/store/modules/global';
import BiometriaService from '@/services/biometria/biometria.service';
import UploadBiometria from '@/components/Biometria/UploadBiometria.vue';

export default {
  name: 'Biometria',
  components: { UploadBiometria },

  props: {
    context: {
      type: String,
      default: 'sie',
      validator: v => ['sie', 'vaiVem'].includes(v),
    },
  },

  data() {
    return {
      step: 1,
      mode: null,
      file: null,
      locked: false,
      isLoading: false,
      fileTypeError: false,
      validationStatus: null,
      authLoading: false,
      authReady: true,
    };
  },

  computed: {
    selectedFileName() {
      return this.file ? this.file.name : '';
    },
  },

  methods: {
    ...mapActions('siePedidos', ['setFormStep']),
    ...mapMutations('siePedidos', ['SET_DOCUMENTO_FOTO']),

    chooseMode(mode) {
      this.mode = mode;
      this.file = null;
      this.validationStatus = null;
      this.$emit('biometria-reset');
      this.step = 2;
    },

    backToStep1() {
      this.step = 1;
      this.mode = null;
      this.file = null;
      this.validationStatus = null;
      this.fileTypeError = false;
      this.$emit('biometria-reset');
    },

    onFileSelected(file) {
      this.validationStatus = null;
      this.fileTypeError = false;
      this.$emit('biometria-reset');
      this.file = file;
    },

    async onValidateClick() {
      if (!this.file) {
        this.validationStatus = 'error';
        GlobalStore.setSnackBar({
          show: true,
          message: 'Selecione uma foto antes de validar.',
          type: 'error',
        });
        return;
      }

      this.isLoading = true;
      this.validationStatus = null;

      try {
        const base64 = await this.fileToBase64(this.file);
        await this.validaBiometria(base64);

        this.validationStatus = 'success';
        this.locked = true;

        if (this.context === 'sie') {
          this.SET_DOCUMENTO_FOTO(this.file);
          this.setFormStep(4);
        }

        if (this.context === 'vaiVem') {
          this.$emit('biometria-ok', base64);
        }

        GlobalStore.setSnackBar({
          show: true,
          message: 'Biometria validada com sucesso!',
          type: 'success',
        });
      } catch (err) {
        if (err === 'LOGIN_ERROR') {
          this.authReady = false;
          return;
        }

        this.validationStatus = 'error';

        GlobalStore.setSnackBar({
          show: true,
          message:
            'Necessário uma foto com melhor resolução/qualidade. Pedimos a gentileza de enviar outra foto.',
          type: 'error',
        });
      } finally {
        this.isLoading = false;
      }
    },

    fileToBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
          const base = reader.result.split('base64,')[1];
          resolve(base);
        };
        reader.onerror = reject;
        reader.readAsDataURL(file);
      });
    },

    async validaBiometria(base64) {
      const obs = await BiometriaService.validaBiometria(base64);

      return new Promise((resolve, reject) => {
        obs.subscribe({
          next: res => {
            if (res?.biometria === true) return resolve(true);
            if (res?.biometria === false) return reject();
            reject('LOGIN_ERROR'); // biometria === null
          },
          error: reject,
        });
      });
    },
  },
};
</script>

<style scoped>
.biometria-card {
  border: none !important;
  box-shadow: none !important;
  background: transparent !important;
  padding-top: 8px !important;
  padding-bottom: 12px !important;
}
</style>
